/***
 * 后台管理模块部分-短信充值页面对接部分
 */
import { post, postJson, imagePost } from '../axios'

const RESOURCE_BASE_PATH = '/members-api/ScoresmemberIntegrate'

/***
 * 查询上传历史
 * @param p
 */
export const queryUploadFileRecord = p =>post(`${RESOURCE_BASE_PATH}/queryUploadFileRecord`, p)


/***
 * 上传修改会员积分文件接口
 * @param p
 */
export const uploadOrderFile = p => imagePost(`${RESOURCE_BASE_PATH}/uploadOrderFile`,p,{ "Content-Type": "multipart/form-data" });
